export default __webpack_public_path__ + "static/media/RE.0c179f29.svg";